import {ServiceClass} from '@/decorators';
import {ConfirmPaymentRequest, ExchangeRateResponse, InitPaymentRequest, PaymentRecord} from '../models/payment/payment.models';
import {BaseApi} from './base.api';

@ServiceClass()
export class PaymentApiService extends BaseApi {
    public async getExchangeRate(): Promise<ExchangeRateResponse> {
        return this.GET_RequestAsync<ExchangeRateResponse>(`${this.ApiUrl}/payments/exchange-rate`);
    }

    public async getCurrentUserPaymentStatus(): Promise<{isPaymentDone: boolean; hasActivePayment: boolean}> {
        return this.GET_RequestAsync<{isPaymentDone: boolean; hasActivePayment: boolean}>(`${this.ApiUrl}/payments/status`);
    }

    public async initPayment(request: InitPaymentRequest): Promise<PaymentRecord> {
        return this.POST_RequestAsync<PaymentRecord>(`${this.ApiUrl}/payments/init`, request);
    }

    public async confirmPayment(planId: string, paymentKey: string, orderId: string, amount: number): Promise<PaymentRecord> {
        const payload: ConfirmPaymentRequest = {
            paymentKey,
            orderId,
            amount: Math.round(amount),
            planId,
        };

        return this.POST_RequestAsync<PaymentRecord>(`${this.ApiUrl}/payments/confirm`, payload);
    }
}
